import { NgModule } from '@angular/core';
import { FilterGroupsPipe } from '../../pipes/filter-groups/filter-groups.pipe';
import { CommonModule } from '@angular/common';


@NgModule({
  exports: [
    FilterGroupsPipe
  ],
  declarations: [
    FilterGroupsPipe
  ],
  imports: [
    CommonModule
  ]
})

export class FilterGroupsModule { }
